import { useState, useEffect } from "react";
import { fetchUbigeoData } from "../helpers/fetch";
import { transformarUbigeo } from "../helpers/transformUbigeo";

export const useUbigeo = () => {
    const [ubigeoData, setUbigeoData] = useState({});
    const [departamento, setDepartamento] = useState("");
    const [provincia, setProvincia] = useState("");
    const [distrito, setDistrito] = useState("");

    useEffect(() => {
        const loadUbigeoData = async () => {
            const { departamentos, provincias, distritos } = await fetchUbigeoData();
            const dataTransformada = transformarUbigeo(departamentos, provincias, distritos);
            setUbigeoData(dataTransformada);
        };
        loadUbigeoData();
    }, []);

    return {
        ubigeoData,
        departamento,
        setDepartamento,
        provincia,
        setProvincia,
        distrito,
        setDistrito,
    };
};
